import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { isDefined } from '@sama/js-core';
import { DirectiveSuperclass } from '@sama/ng-core';
import { filter, Observable, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';
import { ToolName } from '../../../../../../cross-team-shared/tools-names';
import { TaskWorkspaceStore } from '../../../../../h3ml/state/task-workspace-store';
import { getSelectedToolStore } from '../../../../../h3ml/state/task-workspace-store-utils';

@Component({
  selector: 'h3-secondary-toolbar-2d',
  templateUrl: './secondary-toolbar-2d.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SecondaryToolbar2dComponent extends DirectiveSuperclass {
  @Input({ required: true }) videoOutputName!: string;
  selectedTool$: Observable<ToolName>;

  constructor(taskWorkspaceStore: TaskWorkspaceStore) {
    super();

    this.selectedTool$ = this.getInput$('videoOutputName').pipe(
      switchMap((outputName) =>
        getSelectedToolStore(taskWorkspaceStore, outputName).$.pipe(
          filter(isDefined),
          map((selectedTool) => selectedTool.name),
        ),
      ),
    );
  }
}
